export default __webpack_public_path__ + "static/media/product14.261c642d.webp";